import { wait } from '../common'
const ajaxWait = 200

const form = document.querySelector('#form-contact')
const dom = {
  serverMessage: '.server-message',
  cu_nom: '#cu_nom',
  cu_prenom: '#cu_prenom',
  cu_email: '#cu_email',
  cu_mobile: '#cu_mobile',
  cu_object: '#cu_object',
  cu_message: '#cu_message',
  rgpd: '#rgpd',
  process: '.process',
}

const initInputs = () => {
  dom.cu_nom.value = ''
  dom.cu_prenom.value = ''
  dom.cu_email.value = ''
  dom.cu_mobile.value = ''
  dom.cu_object.value = ''
  dom.cu_message.value = ''
  dom.rgpd.checked = false
}

if (form) {
  // query dom objects
  for (const [k, v] of Object.entries(dom)) {
    if (typeof v === 'string') dom[k] = form.querySelector(v)
    if (Array.isArray(v)) dom[k] = form.querySelectorAll(v[0])
  }
  // console.log(dom)

  dom.process.addEventListener('click', send)
  initInputs()
}

async function send() {
  if (!dom.rgpd.checked) {
    dom.serverMessage.innerHTML =
      'Votre consentement à la loi RGPD est nécessaire'
    dom.rgpd.focus()
    return
  }

  dom.serverMessage.innerHTML = 'envoi en cours...'
  dom.process.disabled = true
  await wait(ajaxWait)

  const url = new URL(form.dataset.url)
  url.searchParams.set('action', form.dataset.action)
  url.searchParams.set('nonce', form.dataset.nonce)
  url.searchParams.set('cu_nom', dom.cu_nom.value)
  url.searchParams.set('cu_prenom', dom.cu_prenom.value)
  url.searchParams.set('cu_email', dom.cu_email.value)
  url.searchParams.set('cu_mobile', dom.cu_mobile.value)
  url.searchParams.set('cu_object', dom.cu_object.value)
  url.searchParams.set('cu_message', dom.cu_message.value)
  url.searchParams.set('rgpd', dom.rgpd.checked ? 1 : 0)

  let response
  try {
    response = await fetch(url)
    dom.process.disabled = false
  } catch (error) {
    dom.process.disabled = false
    dom.serverMessage.innerHTML = 'Pas de réseau disponible'
    return
  }

  // http error
  if (!response.ok) {
    dom.serverMessage.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
    return
  }

  const json = await response.json()
  console.log(json)

  // api error
  if (json.data.odoo_error) {
    dom.serverMessage.innerHTML =
      "Une erreur est survenue lors de l'appel à l'api de données."
    return
  }

  if (json.success === false) {
    const prop = Object.keys(json.data)[0] || null
    if (prop && dom[prop]) {
      dom[prop].select()
      dom[prop].focus()
    }
    dom.serverMessage.innerHTML = json.data[prop] || 'Erreur'
    return
  }

  if (!json.data.response.valid) {
    if (json.data.response.missingfields) {
      const prop = json.data.response.missingfields[0] || null
      if (prop && dom[prop]) {
        dom[prop].select()
        dom[prop].focus()
        const step = dom[prop].closest('.step')
        if (step) step.dispatchEvent(new Event('navigate'))
      }
    }
    if (json.data.response.errors?.length > 0) {
      const lines = json.data.response.errors.map((el) => `<div>${el}</div>`)
      dom.serverMessage.innerHTML = lines.join('')
    }
  } else {
    initInputs()
    dom.serverMessage.innerHTML = json.data.message || ''
  }
}
